import { AfterViewInit, Component, Inject, OnInit, Optional, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { zip } from 'rxjs';

import { FilePickerComponent } from '../../common/file-picker/file-picker.component';
import { ImageFormComponent } from '../image-form/image-form.component';
import { PubSubService } from '../../../common/services/pub-sub.service';
import { typeEvents } from '../../../common/enum/type-events';


@Component({
  selector: 'p8-bdc-image-new',
  templateUrl: './image-new.component.html',
  styleUrls: ['./image-new.component.scss']
})
export class ImageNewComponent implements OnInit, AfterViewInit {
  @ViewChildren(ImageFormComponent) imageFormComponents:  QueryList<ImageFormComponent>;
  @ViewChild(FilePickerComponent, { static: true }) filePickerComponent: FilePickerComponent;

  files: File[] = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<ImageNewComponent>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pubSubSvc: PubSubService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.filePickerComponent.click();
  }

  remove(index: number) {
    this.files.splice(index, 1);
  }

  onSubmit() {
    const imagesToUpload$ = this.imageFormComponents.map(d => d.save());

    zip(...imagesToUpload$).subscribe(data => {
      this.pubSubSvc.publish(typeEvents.imageSaved, 'Les images ont bien été ajoutées');
      if (this.dialogRef) {
        this.dialogRef.close(true);
      } else {
        this.router.navigate(['..'], {relativeTo: this.activatedRoute});
      }
    });
  }

  onCancel() {
    if (this.dialogRef) {
      this.dialogRef.close(false);
    } else {
      this.router.navigate(['..'], {relativeTo: this.activatedRoute});
    }
  }

  isImageFormInvalid(element: ImageFormComponent, index: number, array: ImageFormComponent[]) {
    return !element.isValid();
  }

  // isFormImageValid: boolean = false;

  isValid(): boolean {
    return this.files.length > 0 && this.imageFormComponents.filter(this.isImageFormInvalid).length === 0;
  }
}
